// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"864b1e58","455":"e3600264","977":"d4384893"}[chunkId] + ".chunk.js";
};